// extracted by mini-css-extract-plugin
export default {"root":"QgqImV_k","input":"IFhySoSj","buttons":"p_GhCXa3","button":"e65WpdXq"};